import { apiGet, apiPatch, apiPost } from './client';
import type {
  User,
  UserRow,
  UserCreateDto,
  UserUpdateDto,
  UserBatchRequest,
} from '../types/User';

export function getUsers(): Promise<User[]> {
  return apiGet<User[]>('/api/users');
}

function toCreate(u: UserRow): UserCreateDto {
  return {
    email: u.email,
    password: u.password ?? '',
    displayName: u.displayName,
    tenantId: u.tenantId,
    isActive: u.isActive,
    roleIds: u.roleIds,
  };
}

function toUpdate(u: UserRow): UserUpdateDto {
  // password: only send when the admin actually typed a new one. Empty/absent
  // → null so the server's COALESCE preserves the existing hash. email is
  // frozen post-create in the UI but we send the current value; the server
  // treats matching values as no-op.
  const password = u.password && u.password.length > 0 ? u.password : null;
  return {
    userId: u.userId,
    email: u.email,
    password,
    displayName: u.displayName,
    tenantId: u.tenantId,
    isActive: u.isActive,
    roleIds: u.roleIds,
  };
}

export function saveBatchUsers(
  added: UserRow[],
  modified: UserRow[],
  deletedIds: number[],
): Promise<User[]> {
  const body: UserBatchRequest = {
    added: added.map(toCreate),
    modified: modified.map(toUpdate),
    deleted: deletedIds,
  };
  return apiPatch<UserBatchRequest, User[]>('/api/users/batch', body);
}

/** SysAdmin / users:Edit — clears failedLoginCount + lockoutUntil of one user. */
export function unlockUser(userId: number): Promise<void> {
  return apiPost<undefined, void>(`/api/users/${userId}/unlock`);
}
